import React from "react";
import { createPortal } from "react-dom";

import Toast from "./Toast";

interface ToastContainerProps {
  toasts: any[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts }) => {
  return createPortal(
    <aside className="fixed top-0 right-0 z-90 mt-18 px-4 w-full sm:w-96">
      {toasts.map((t) => (
        <Toast id={t.id} key={t.id}>
          {t.content}
        </Toast>
      ))}
    </aside>,
    document.body
  );
};

export default ToastContainer;
